import React, { FunctionComponent, useContext, useState } from 'react';
import { SIGN_UP_STATES } from '@jetslash/market-frontend-shared-core/src/models/user';
import { FrontPluginContext } from '@/contexts/FrontPluginContext';
import useSignUpWizard from '@/hooks/useSignUpWizard';
import useCurrentUser from '@jetslash/market-frontend-shared-core/src/hooks/useCurrentUser';
import Row from '../layout/Row';
import Col from '../layout/Col';
import Radio from '../forms/fields/Radio';
import SignInForm from '../forms/SignInForm';
import SignUpWizard from './SignUpWizard';
import LoadingComponentOverlay from '../loading/LoadingComponentOverlay';

interface IProps {
  logInOnly?: boolean;
}

const LogInOrSignUpForm: FunctionComponent<IProps> = ({ logInOnly = false }) => {
  const [formSelected, setFormSelected] = useState(logInOnly ? 'log_in_selected' : 'sign_up_selected');
  const { refreshCurrentUser } = useCurrentUser();
  const toggleForms = (event) => {
    setFormSelected(event.target.value);
  };

  const showLogIn = formSelected === 'log_in_selected';

  const { signUpUser, loading } = useSignUpWizard();
  const hideFormToggle = signUpUser && signUpUser?.signUpState !== SIGN_UP_STATES.newMarketUser;

  const { onFrontPluginPage } = useContext(FrontPluginContext);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onSignInSuccess = (data) => {
    if (onFrontPluginPage) {
      refreshCurrentUser();
    } else {
      window.location.reload();
    }
  };

  return (
    <>
      <LoadingComponentOverlay loading={loading} />
      {!logInOnly && (
        <Row style={hideFormToggle ? { display: 'none' } : {}}>
          <Col span={24}>
            <div style={{ marginLeft: 10, marginRight: 10, marginBottom: 10 }}>
              <Radio.Group
                style={{ width: '100%' }}
                onChange={toggleForms}
                defaultValue={formSelected}
                value={formSelected}
              >
                <Radio.Button style={{ width: '50%', textAlign: 'center' }} value="log_in_selected">
                  Log In
                </Radio.Button>
                <Radio.Button style={{ width: '50%', textAlign: 'center' }} value="sign_up_selected">
                  Sign Up
                </Radio.Button>
              </Radio.Group>
            </div>
          </Col>
        </Row>
      )}
      <Row>
        <Col span={24}>
          {showLogIn && <SignInForm onSignInSuccess={onSignInSuccess} />}
          {!showLogIn && <SignUpWizard />}
        </Col>
      </Row>
    </>
  );
};

export default LogInOrSignUpForm;
